import { useMutation } from "@apollo/react-hooks";
import { useAsyncCallback } from 'react-use-async-callback';
import gql from "graphql-tag";
import { AsyncActionStatus } from '../../../shared/abstractStore';
import { deleteDriverMetricMutation, deleteDriverMetricMutationVariables } from '../generated/deleteDriverMetricMutation';
import { driverMetricFieldsFragment } from '../models/DriverMetric';

/**
 * Get a callback to delete a DriverMetric in the store.
 */
export function useDeleteDriverMetricCallback(): [(id: string) => Promise<void>, AsyncActionStatus] {
    const [mutationAction, { error }] = useMutation<deleteDriverMetricMutation, deleteDriverMetricMutationVariables>(
        gql`
            mutation deleteDriverMetricMutation ($id: ID!) {
                deleteDriverMetric(id: $id) {
                    ...driverMetricFields
                }
            }

            ${driverMetricFieldsFragment}
        `
    );

    // Wrap the mutation in a standard callback.
    const [action, { isExecuting, errors: actionErrors }] = useAsyncCallback(async (id: string) => {
        const result = await mutationAction({ variables: { id: id } });
        if (result.errors && result.errors.length) {
            throw result.errors;
        }
    }, [mutationAction]);

    return [action, { isExecuting: isExecuting, errors: error ? error.message : actionErrors }];
}
